import { render, staticRenderFns } from "./BlockCustomer.vue?vue&type=template&id=64800e76&"
import script from "./BlockCustomer.vue?vue&type=script&lang=js&"
export * from "./BlockCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports